// extracted by mini-css-extract-plugin
export default {"objectName":"RentalObjectSettings_objectName__3w2b9","wrapper":"RentalObjectSettings_wrapper__weMVT"};